import * as module from "module";
import { ActivateCCDBillingAccountStepComponent } from "../connected-cockpit-device/activate-ccd-billing-account-step.component";
import { ActivateCCDEulaStepComponent } from "../connected-cockpit-device/activate-ccd-eula-step.component";
import { ActivateCCDPromoteRegisterStepComponent } from "../connected-cockpit-device/activate-ccd-promote-register-step.component";
import { ActivateCCDModalComponent } from "../connected-cockpit-device/activate-ccd-modal.component";
import { ActivateCCDOverviewStepComponent } from "../connected-cockpit-device/activate-ccd-overview-step.component";
import { AircraftRowComponent } from "./aircraft-row.component";
import { AircraftRowFormTemplateComponent } from "./aircraft-row-form-template.component";
import { AuthGuardService } from "../auth-guard.service";
import { AvdbService } from "../avdb.service";
import { ConnextService } from "../connext.service";
import { UserService } from "../user.service";
import { CommonModule } from "@angular/common";
import { ConnectedCockpitDeviceRowComponent } from "./connected-cockpit-device-row.component";
import { ConnectedCockpitDeviceDetailsRowComponent } from "./connected-cockpit-device-details-row.component";
import { DateUtilService } from "./date-util.service";
import { DeviceRowTemplateComponent } from "./device-row-template.component";
import { DevicesListComponent } from "./devices-list.component";
import { DevicesListTemplateComponent } from "./devices-list-template.component";
import { FlyCommonModule } from "fly-common/fly-common.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { PreferredUpdateTimeComponent } from "./preferred-update-time.component";
import { RouterModule, Routes } from "@angular/router";
import { SubscribedServicesComponent } from "./subscribed-services.component";
import { SharedModule } from "../shared/shared.module";
import { ActivateCCDTrialModalComponent } from "../connected-cockpit-device/activate-ccd-trial-modal.component";
import { ActivateCcdCustomerConnextTrialStepComponent } from "../connected-cockpit-device/activate-ccd-customer-connext-trial-step.component";
import { ActivateCcdLsqCapableSelectionStepComponent } from '../connected-cockpit-device/activate-ccd-lsq-capable-selection-step.component';
import { ActivateCcdOemConnextTrialSubscriptionStepComponent } from "../connected-cockpit-device/activate-ccd-oem-connext-trial-subscription-step.component";
import { ActivateCCDOemAvdbSubscriptionStepComponent } from "../connected-cockpit-device/activate-ccd-oem-avdb-subscription-step.component";
import { ActivateCcdTrialUnavailableDueToDealerAccessComponent } from "../connected-cockpit-device/activate-ccd-trial-unavailable-due-to-dealer-access.component";
import { AircraftInviteInformationComponent } from "./aircraft-invite-information.component";
import { AircraftShareVisibilityService } from "../aircraft-details/aircraft-share-visibility.service";
import { ConnextTrialDetailsModalComponent } from "../connected-cockpit-device/connext-trial-details-modal.component";
import { SubscribedServicesNotActiveHelpModalComponent } from "./subscribed-services-not-active-help-modal.component";
import { UserDealerAccessGrantService } from "../user-dealer-access-notice/user-dealer-access-grant.service";
import { UserDealerAccessNoticeComponent } from "../user-dealer-access-notice/user-dealer-access-notice.component";
import { ActivateCcdDealerConnextTrialStepComponent } from "../connected-cockpit-device/activate-ccd-dealer-connext-trial-step.component";
import { ActivateCcdConnextTrialModalBodyComponent } from "../connected-cockpit-device/activate-ccd-connext-trial-modal-body.component";
import { OemService } from "../oem.service";
import { SynchronizeTerrainModal } from '../connected-cockpit-device/activate-ccd-synchronize-terrain-step.component';
import { ConnectedCockpitDeviceSubscribedServicesComponent } from './connected-cockpit-device-subscribed-services.component';
import { TurbopropService } from '../turboprop.service';
import { ConnectedCockpitOTCRowComponent } from "./connected-cockpit-otc-row.component";
import { ConnectedCockpitDeviceTelephonyDetailsComponent } from "./connected-cockpit-device-telephony-details.component";
import { ConnectedCockpitActivationRowComponent } from "./connected-cockpit-activation-row.component";
import { PermissionAuthGuardService } from "device-management/permission-auth-guard";
import { HerculesDeviceRowComponent } from "./hercules-device-row.component";

const routes: Routes = [
	{
		path: "list",
		component: DevicesListComponent,
		canActivate: [AuthGuardService, PermissionAuthGuardService],
		data: {permissionIds: [module.config().permissionsAircraftReadId, module.config().permissionsDeviceReadId]}
	},
];

@NgModule({
	imports: [
		CommonModule,
		FlyCommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(routes),
		SharedModule,
	],
	exports: [
		ActivateCCDTrialModalComponent,
		AircraftRowComponent,
		AircraftRowFormTemplateComponent,
		ConnectedCockpitActivationRowComponent,
		ConnectedCockpitDeviceRowComponent,
		ConnectedCockpitOTCRowComponent,
		ConnextTrialDetailsModalComponent,
		DeviceRowTemplateComponent,
		DevicesListComponent,
		DevicesListTemplateComponent,
		HerculesDeviceRowComponent,
		PreferredUpdateTimeComponent,
		RouterModule,
		SubscribedServicesComponent,
		ConnectedCockpitDeviceSubscribedServicesComponent,
	],
	declarations: [
		ActivateCCDBillingAccountStepComponent,
		ActivateCcdCustomerConnextTrialStepComponent,
		ActivateCCDEulaStepComponent,
		ActivateCcdLsqCapableSelectionStepComponent,
		ActivateCcdConnextTrialModalBodyComponent,
		ActivateCCDPromoteRegisterStepComponent,
		ActivateCCDModalComponent,
		ActivateCCDOemAvdbSubscriptionStepComponent,
		ActivateCcdOemConnextTrialSubscriptionStepComponent,
		ActivateCCDOverviewStepComponent,
		ActivateCCDTrialModalComponent,
		ActivateCcdTrialUnavailableDueToDealerAccessComponent,
		ActivateCcdDealerConnextTrialStepComponent,
		AircraftInviteInformationComponent,
		AircraftRowComponent,
		AircraftRowFormTemplateComponent,
		ConnectedCockpitActivationRowComponent,
		ConnectedCockpitDeviceRowComponent,
		ConnectedCockpitDeviceDetailsRowComponent,
		ConnectedCockpitDeviceTelephonyDetailsComponent,
		ConnectedCockpitOTCRowComponent,
		ConnextTrialDetailsModalComponent,
		DeviceRowTemplateComponent,
		DevicesListComponent,
		DevicesListTemplateComponent,
		HerculesDeviceRowComponent,
		PreferredUpdateTimeComponent,
		SubscribedServicesComponent,
		SubscribedServicesNotActiveHelpModalComponent,
		SynchronizeTerrainModal,
		UserDealerAccessNoticeComponent,
		ConnectedCockpitDeviceSubscribedServicesComponent,
	],
	providers: [
		AircraftShareVisibilityService,
		AvdbService,
		ConnextService,
		DateUtilService,
		OemService,
		UserDealerAccessGrantService,
		UserService,
		TurbopropService,
		{ provide: "connextLteWifiEligibleConnectedCockpitDeviceIds", useValue: module.config().connextLteWifiEligibleConnectedCockpitDeviceIds },
		{ provide: "deviceCount", useValue: module.config().deviceCount },
		{ provide: "oneTimeCodeFaqUrl", useValue: module.config().oneTimeCodeFaqUrl },
		{ provide: "telephonyConnectedCockpitDeviceIds", useValue: module.config().telephonyConnectedCockpitDeviceIds }
	],
})
export class DevicesListModule {
}
